import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../services/language.service';

interface FaqItem {
  question: string;
  answer: string;
  showAnswer: boolean;
}

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  faqItems: FaqItem[] = [];

  constructor(private langService: LanguageService) { }

  ngOnInit(): void {
    this.loadFaqItems();
  }

  private loadFaqItems(): void {
    const currentLang = this.langService.getLang(); // Assuming this returns a language code like 'es'

    if (currentLang === 'es') {
      // FAQ items for Spanish
      this.faqItems = [
        {
          question: "¿Cómo puedo acceder a la aplicación de Jimm Monitoring?",
          answer: "Para acceder a la aplicación, visita nuestra web principal www.jimmonitoring.com y haz clic en \"Acceso clientes\". Ingresa tu email de usuario y clave de acceso para iniciar sesión",
          showAnswer: false
        },
        {
          question: "¿Cómo puedo ver y filtrar los datos en el Dashboard principal?",
          answer: "En el Dashboard principal, puedes filtrar los datos por criterios como país, zona, proyecto, personas o dispositivos, además de ajustar el rango de fechas. Los filtros los puedes encontrar en la parte de arriba de la pantalla de Dashboard principal o pinchando en la casa",
          showAnswer: false
        },
        {
          question: "¿Cómo puedo modificar los datos de mi empresa?",
          answer: "Si eres un usuario administrador, ve al menú \"Empresas\" y podrás modificar los datos de tu empresa, incluyendo subir una imagen del logo.",
          showAnswer: false
        },
        {
          question: "¿Cómo doy de alta nuevos usuarios en la aplicación?",
          answer: "En el menú \"Usuarios\", los administradores pueden añadir nuevos usuarios haciendo clic en \"Nuevo usuario\" y completando los datos requeridos.",
          showAnswer: false
        },
        {
          question: "¿Cómo gestiono los trabajadores y sus dispositivos?",
          answer: "En el menú \"Trabajadores\", puedes dar de alta nuevos trabajadores y vincularlos a dispositivos específicos. Utiliza el botón \"Nuevo Trabajador\" para añadir nuevos registros.",
          showAnswer: false
        },
        {
          question: "¿Qué son las Zonas y cómo se utilizan en la gestión de proyectos?",
          answer: "Las Zonas son áreas geográficas definidas para facilitar la organización de proyectos. Puedes ver y gestionar las Zonas en el menú correspondiente y asignarlas a diferentes proyectos.",
          showAnswer: false
        },
        {
          question: "¿Cómo vinculo un proyecto a varias Zonas?",
          answer: "Al crear o editar un proyecto, selecciona las Zonas que abarcará. Esto permite una gestión eficiente de actividades en distintas áreas.",
          showAnswer: false
        },
        {
          question: "¿Qué información proporcionan los dispositivos de Jimm Monitoring?",
          answer: "Los dispositivos ofrecen seguimiento en tiempo real de la ubicación y estado de seguridad de los trabajadores, asegurando una supervisión eficaz de los proyectos.",
          showAnswer: false
        },
        {
          question: "¿Cómo configuro y gestiono un dispositivo en la aplicación?",
          answer: "En el menú \"Dispositivos\", puedes añadir nuevos dispositivos, vincularlos a proyectos y trabajadores, y configurar sus detalles. Usa el botón \"Nuevo dispositivo\" para registrar uno nuevo.",
          showAnswer: false
        },
        {
          question: "¿Se almacenará, compartirá o utilizará el número de identificación para otros fines?",
          answer: "El Nºde identificación en cumplimiento de la normativa de protección de datos personalesno será almacenado, compartido, ni utilizado para ningún otro fin sin el consentimiento expreso del titular.",
          showAnswer: false
        }
      ];
    } else {
      // FAQ items for English
      this.faqItems = [
        {
          question: "How can I access the Jimm Monitoring application?",
          answer: "To access the application, visit our main website at www.jimmonitoring.com and click on \"Client Access.\" Enter your user email and password to log in.",
          showAnswer: false
        },
        {
          question: "How can I view and filter data on the main Dashboard?",
          answer: "On the main Dashboard, you can filter data by criteria such as country, region, project, people, or devices, as well as adjust the date range. Filters can be found at the top of the Dashboard screen or by clicking on the home icon.",
          showAnswer: false
        },
        {
          question: "How can I modify my company’s data?",
          answer: "If you are an administrator, go to the \"Companies\" menu where you can modify your company’s data, including uploading a company logo image.",
          showAnswer: false
        },
        {
          question: "How do I add new users to the application?",
          answer: "In the \"Users\" menu, administrators can add new users by clicking on \"New User\" and filling in the required details.",
          showAnswer: false
        },
        {
          question: "How do I manage workers and their devices?",
          answer: "In the \"Workers\" menu, you can add new workers and link them to specific devices. Use the \"New Worker\" button to add new records.",
          showAnswer: false
        },
        {
          question: "What are Zones and how are they used in project management?",
          answer: "Zones are defined geographical areas to facilitate project organization. You can view and manage Zones in the corresponding menu and assign them to different projects.",
          showAnswer: false
        },
        {
          question: "How do I link a project to multiple Zones?",
          answer: "When creating or editing a project, select the Zones it will cover. This allows for efficient management of activities in different areas.",
          showAnswer: false
        },
        {
          question: "What information do Jimm Monitoring devices provide?",
          answer: "The devices offer real-time tracking of the location and security status of workers, ensuring effective project supervision.",
          showAnswer: false
        },
        {
          question: "How do I configure and manage a device in the application?",
          answer: "In the \"Devices\" menu, you can add new devices, link them to projects and workers, and configure their details. Use the \"New Device\" button to register a new one.",
          showAnswer: false
        },
        {
          question: "Will the identification number be stored, shared, or used for other purposes?",
          answer: "The identification number, in compliance with personal data protection regulations, will not be stored, shared, or used for any other purpose without the express consent of the owner.",
          showAnswer: false
        }
      ];
    }
  }

  toggleAnswer(item: FaqItem): void {
    item.showAnswer = !item.showAnswer;
  }
}
